import { Pipe, PipeTransform } from '@angular/core';
import { CustomField, CustomFieldsDropdownOptions, CustomFieldType, CustomFieldUtility, DateUtility, Entity, JobUtility } from '@jms/model';
import * as Enumerable from 'linq';

export interface CustomFieldDrodownValue {
    group: string;
    value: string;
    itemOrder: number;
    groupOrder: number;
}

@Pipe({
    name: 'customFieldDrodownValues',
    standalone: false
})
export class CustomFieldDrodownValuesPipe implements PipeTransform {


    transform(value: CustomField): CustomFieldDrodownValue[] {

        const dropdowns = [
            CustomFieldType.Dropdown,
            CustomFieldType.DropdownMulti,
        ];

        if (!dropdowns.includes(value?.type))
            return [];

        const options = value?.options as CustomFieldsDropdownOptions;
        let items = [] as CustomFieldDrodownValue[];
        //When do not sort is false (or not set), it means we want to sort alphabetically
        //otherwise, we leave the natural sort order
        const sortByIndex = options?.doNotSort ?? false;
        Enumerable
            .from(options?.groups)
            .forEach((x, ixg) => {
                Enumerable
                    .from(x.items.split(/\r?\n/))
                    .select(i => i?.trim())
                    .where(i => i !== null && i !== '')
                    .forEach((i, ix) => {
                        const item = {
                            group: x.name,
                            value: i,
                            itemOrder: ix,
                            groupOrder: ixg
                        };
                        items.push(item);
                    });
            });

        items = Enumerable
            .from(items)
            .orderBy(x => sortByIndex ? x.groupOrder : x.group)
            .thenBy(x => sortByIndex ? x.itemOrder : x.value)
            .toArray();

        return items;
    }
}
